import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';

import styled from 'styled-components';

import { withAPIService } from '../../networking';
import { withStore } from '../../store';

const Wrapper = styled.div`
  width: 100%;
  padding: 25px 60px;
  background-color: var(--white);

  @media only screen and (max-width: 700px) {
    padding: 25px 5px;
  }
`;

const Copy = styled.p`
  font-size: 0.75em;
  line-height: 1.375em;
  max-width: 450px;
  color: var(--grey-3);
  margin-left: 0.75rem;
`;

const Button = styled.button`
  font-size: 0.75em;
  line-height: 1.375em;
  padding: 0 0.75rem;
  border: none;
  color: var(--grey-4);
  font-weight: bold;
  background-color: var(--white);

  &:first-of-type {
    margin-left: 0;
  }
`;

const FaqLink = styled(Link)`
  font-size: 0.85em;
  text-decoration: none;

  a {
    text-decoration: none;
    color: black;
    font-weight: bold;
    font-size: 0.86em;
  }
`;

const Cookie = styled.span`
  font-size: 0.75em;
  line-height: 1.375em;
  padding: 0 0.55rem;
  min-height: 2rem;
  color: var(--grey-4);
  font-weight: bold;
  white-space: nowrap;
`;

const FooterWrapper = styled.div`
  @media only screen and (max-width: 700px) {
    display: flex;
    flex-direction: column;
  }
`;

const CopyContainer = styled.div`
  margin-top: 8px;
`;
type FooterProps = RouteComponentProps;


function FooterCom(props: FooterProps): JSX.Element {
  const {
    location: { pathname }
  } = props;

  const currentPage = pathname?.split('/').reverse()[0];
  const { t } = useTranslation();

  return (
    <Wrapper>
      <FooterWrapper>
        <a
          data-event="common-click"
          data-metrics-desc="terms"
          data-metrics-type="BUTTON"
          rel="noopener noreferrer"
          href="https://www.cargill.com/page/website-terms"
          target="_blank"
        >
          <Button type="button">
            {t('footer.termsAndConditions')}
          </Button>
        </a>

        <a
          data-event="common-click"
          data-metrics-desc="privacy"
          data-metrics-type="BUTTON"
          rel="noopener noreferrer"
          href="https://www.cargill.com/page/privacy"
          target="_blank"
        >
          <Button type="button">
            {t('footer.privacyPolicy')}
          </Button>
        </a>

        <Cookie id="teconsent" />

        {currentPage !== 'FaqPage' && (
          <FaqLink to="/FaqPage">
            {t('FaqName')}
          </FaqLink>
        )}
      </FooterWrapper>

      <CopyContainer>
        <FaqLink to="/FaqPage">
          <Copy>{t('footer.copyright')}</Copy>
        </FaqLink>
      </CopyContainer>
    </Wrapper>
  );
}

const connectRouter = withRouter(FooterCom);
const connectAPI = withAPIService(connectRouter);
const Footer = withStore(connectAPI);

export default Footer;
